module.exports = __webpack_public_path__ + "static/media/understand.3693e96f.mp3";